'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.repStatusColors = exports.repStatuses = undefined;

var _repStatusColors;

var _reactUtils = require('react-utils');

var _colors = require('HubStyleTokens/colors');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var repStatuses = exports.repStatuses = (0, _reactUtils.keyMirror)({
  ONLINE: null,
  OFFLINE: null
});

var repStatusColors = exports.repStatusColors = (_repStatusColors = {}, _defineProperty(_repStatusColors, repStatuses.ONLINE, _colors.OZ), _defineProperty(_repStatusColors, repStatuses.OFFLINE, _colors.CANDY_APPLE), _repStatusColors);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/constants/RepStatus.js
// module id = 429
// module chunks = 0